'use strict';

import $ from 'jquery';

let popup = {

  $overlay: $('<div class="popup-overlay"></div>'),
  $loader: $('<svg class="icon-svg" style="width:4rem; height:4rem; pointer-events:none; fill:#ffffff;"><use xlink:href="#icon-loader"></use></svg>'),
  $content: null,

  openPopup: function(ajaxUrl, callBack){
    var self = this;

    // Show overlay (with loader or content which was already loaded)
    $('body').append(this.$overlay);
    this.$overlay.show();

    if(!this.$content){
      // Popup is not loaded yet > get popup HTML by ajax and append it to overlay
      this.$overlay.append(this.$loader);

      $.ajax({
        url: ajaxUrl,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          console.log('openPopup failed to load popup data from ajaxUrl ' + ajaxUrl, textStatus, errorThrown);
          self.closePopup();
        },
        success: function(data){
          try {
            self.$content = $(data.popupHTML);
            self._initPopup();
            self.$overlay.empty(); // clear overlay
            self.$overlay.append(self.$content); // append new content
            if(typeof callBack === 'function'){
              callBack();
            }
          } catch(err){
            console.log('openPopup failed to find popupHTML from ajaxUrl ' + ajaxUrl, err);
            self.closePopup();
          }
        },
      });
    }
  },

  closePopup: function(clear){
    this.$overlay.hide();
    if(clear){
      this.$overlay.empty();
      this.$content = null;
    }
  },

  setView: function(view){
    var $nextView = (view ? this.$content.find('[data-popup-view="'+view+'"]') : this.$content.find('[data-popup-view]').first());
    if($nextView.length){
      this.$content.find('[data-popup-view]').hide();
      $nextView.show();
    }
  },

  _initPopup: function(){
    var self = this;
    this.$content.on('click', '[data-popup-close]', function(evt){
      evt.preventDefault();
      self.closePopup();
    });
  },
};

export default popup;
